import React from 'react';
import { OverlayTrigger, Popover as BSPopover } from 'react-bootstrap';

export interface PopoverProps {
  message: React.ReactNode | JSX.Element | string;
  requiresMessage?: boolean;
  id?: string;
  disabledSubject?: boolean;
  placement?: "top" | "right" | "bottom" | "left";
}

export const Popover: React.FC<PopoverProps> = (props) => {


  const popover = (
    <BSPopover id={props.id || 'id-popover'}>
      {props.message}
    </BSPopover>
  );

  const placement = props.placement || 'bottom';

  //support not supplying this requiresMessage prop.
  if (props.requiresMessage === undefined || props.requiresMessage) {
    if (props.disabledSubject) {
      return (
        <OverlayTrigger placement={placement} overlay={popover}>
          <div style={{display: 'inline-block'}}>
            <div style={{pointerEvents: "none"}}>
              {props.children}
            </div>
          </div>
        </OverlayTrigger>
      )
    } else {
      return (
        <OverlayTrigger placement={placement} overlay={popover}>
          {/* This is a hack to make county-suite-ui buttons work. */}
          <span>
            {props.children}
          </span>
        </OverlayTrigger>
      ) 
    }
  }

  return (<>{props.children}</>)
}

(Popover as any).displayName = 'Popover';